let airshipTimeout;

function waitForUA(timeout = 5000) {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (window.UA) {
        resolve(window.UA);
      }
    }, timeout);
  });
}

export async function dispatchAirshipEvent() {
  const sdk = await waitForUA();

  await sdk.create();

  const data = window.mktg_data;

  if (data) {
    const filteredData = JSON.parse(JSON.stringify(data));

    delete filteredData.member_number;

    if (filteredData.session) {
      delete filteredData.session.customer;
    }

    const airship_pageLoad = new sdk.CustomEvent("airship_pageLoad", 1, filteredData);

    airship_pageLoad.track();
  }
}

export function fireTrack(identifier, addtionalData) {
  let browserWindow;

  if (typeof window !== "undefined" && window._satellite) {
    browserWindow = window;

    if (addtionalData) {
      browserWindow._satellite.track(identifier, addtionalData);
    } else {
      browserWindow._satellite.track(identifier);
    }
  }
}

function mktgAdobeSatelliteTracking(browserWindow, satelliteTrack, satelliteTrackData) {
  if (satelliteTrack && browserWindow._satellite) {
    browserWindow._satellite.track(satelliteTrack, satelliteTrackData);
  }
}

function dispatchMktgDataEvent(detail) {
  window.document?.dispatchEvent(new CustomEvent("mktgDataUpdate", { detail }));
}

export function sendToDataLayer(data, satelliteTrack, satelliteTrackData) {
  let browserWindow;

  clearTimeout(airshipTimeout);

  if (typeof window !== "undefined") {
    browserWindow = window;

    browserWindow["mktg_data"] = data;
    dispatchMktgDataEvent("sendToDataLayer");
    persistData(data);

    mktgAdobeSatelliteTracking(browserWindow, satelliteTrack, satelliteTrackData);

    airshipTimeout = setTimeout(() => {
      dispatchAirshipEvent();
    }, 1000);
  }
}

export function updateDataLayer(data, satelliteTrack, satelliteTrackData) {
  let browserWindow;

  if (typeof window !== "undefined") {
    browserWindow = window;
    const updatedData = { ...browserWindow["mktg_data"], ...data };

    browserWindow["mktg_data"] = updatedData;
    dispatchMktgDataEvent("updateDataLayer");
    persistData(updatedData);

    mktgAdobeSatelliteTracking(browserWindow, satelliteTrack, satelliteTrackData);
  }
}

function persistData(data) {
  const { session } = data ?? {};

  if (typeof window !== "undefined" && typeof session === "object") {
    window.sessionStorage?.setItem?.(
      "mktg_data",
      JSON.stringify({
        session,
      })
    );
  }
}

export function sendToAdobeDataLayer(data, satelliteTrack, satelliteTrackData) {
  let browserWindow;

  if (typeof window !== "undefined") {
    browserWindow = window;

    browserWindow["adobeDataLayer"] = browserWindow.adobeDataLayer || [];
    browserWindow["adobeDataLayer"].push(data);

    dispatchMktgDataEvent("sendToAdobeDataLayer");

    mktgAdobeSatelliteTracking(browserWindow, satelliteTrack, satelliteTrackData);
  }
}
